import { render, staticRenderFns } from "./FundWallet.vue?vue&type=template&id=1bd5173f&scoped=true&"
import script from "./FundWallet.vue?vue&type=script&setup=true&lang=ts&"
export * from "./FundWallet.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd5173f",
  null
  
)

export default component.exports